import { useEffect, useState } from "react";

const useMousePosition = () => {
    const [position, setPosition] = useState<{ x: null | number; y: null | number }>({ x: null, y: null });
    useEffect(() => {
        const updatePosition = (ev: MouseEvent) => {
            setPosition({ x: ev.clientX, y: ev.clientY });
        };
        window.addEventListener("mousemove", updatePosition);
        return () => {
            window.removeEventListener("mousemove", updatePosition);
        };
    }, []);
    return position;
};

export default useMousePosition;
